import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';

import { RegistryTableComponent } from './registry-table.component';
import { NoContentModule } from 'components/no-content/no-content.module';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DisplayHtmlModule, PopoverLayoutModule, FileUploadModule, OptionDropdownModule } from '@certemy/ui-components';
import { AttachmentsPopoverComponent } from 'components/registry-table/tabel-popover/attachments-popover.component';
import { OnDemandPsvButtonModule } from 'components/on-demand-psv-button/on-demand-psv-button.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    NoContentModule,
    NgbPopoverModule,
    PopoverLayoutModule,
    DisplayHtmlModule,
    FileUploadModule,
    NgbTooltipModule,
    OptionDropdownModule,
    OnDemandPsvButtonModule,
  ],
  exports: [RegistryTableComponent, AttachmentsPopoverComponent],
  declarations: [RegistryTableComponent, AttachmentsPopoverComponent],
  providers: [],
})
export class RegistryTableModule {}
